export default __webpack_public_path__ + "static/media/simonSound2.1eb5aa4c.mp3";